import { gql } from '@apollo/client';

export const INSTITUTIONS_FILTERED = gql`
  query InstitutionsFiltered($input: FilterInstitutions!) {
    institutions: filteredInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
